import { Injectable } from '@angular/core';
import { Observable, map, throwError } from 'rxjs';
import { environment } from 'app/environments/environment';
import { HttpClient } from '@angular/common/http';
import { LocationAPIResponse, Location } from 'app/core/interfaces/location';
import { LocationAdapter } from 'app/core/adapters/location.adapter';

@Injectable({
  providedIn: 'root',
})
export class OrganizationLocationService {
  constructor(private http: HttpClient, private locationAdapter: LocationAdapter) {}

  list() {
    return this.http.get(`${environment.apiUrl}/secretarias-location`);
  }

  listLocationForAffiliation() {
    return this.http.get(`${environment.apiUrl}/secretarias-location/list_location_for_affiliation`);
  }

  listNew(): Observable<Location[]> {
    return this.http
      .get<LocationAPIResponse[]>(`${environment.apiUrl}/secretarias-location`)
      .pipe(map((locations: LocationAPIResponse[]) => locations.map((location) => this.locationAdapter.adapterToModel(location))));
  }

  show(organizationId: string) {
    return this.http.get(`${environment.apiUrl}/secretarias-location/${organizationId}`);
  }

  showByOrganization(organizationId: string): Observable<Location> {
    return this.http
      .get<LocationAPIResponse>(`${environment.apiUrl}/secretarias-location/organization_id/${organizationId}`)
      .pipe(map((location: LocationAPIResponse) => this.locationAdapter.adapterToModel(location)));
  }

  showNew(organization_id: string): Observable<Location> {
    return this.http
      .get<LocationAPIResponse>(`${environment.apiUrl}/secretarias-location/${organization_id}`)
      .pipe(map((location: LocationAPIResponse) => this.locationAdapter.adapterToModel(location)));
  }

  create(params: any) {
    return this.http.post(`${environment.apiUrl}/secretarias-location`, params);
  }

  createNew(location: Location): Observable<Location> {
    const locationFHIR = this.locationAdapter.adaptToAPIFormat(location);

    return this.http
      .post<LocationAPIResponse>(`${environment.apiUrl}/secretarias-location`, locationFHIR)
      .pipe(map((location) => this.locationAdapter.adapterToModel(location)));
  }

  update(organizationId: string, params: any) {
    return this.http.put(`${environment.apiUrl}/secretarias-location/${organizationId}`, params);
  }

  updateNew(location_id: string, location: Location) {
    const locationFHIR = this.locationAdapter.adaptToAPIFormat(location);

    return this.http
      .put<LocationAPIResponse>(`${environment.apiUrl}/secretarias-location/${location_id}`, locationFHIR)
      .pipe(map((location) => this.locationAdapter.adapterToModel(location)));
  }
}
